import React from 'react';

export default function InlineOptions(props)
{
    return (
        <>
            <div className="radio">
                <label>
                    <input type="radio" value={props.value} name={props.name} onChange={props.onChange} checked={props.value === props.default}/> 
                    {props.label} 
                </label>
            </div>
        </>
    )
}